export function getProductPrices({ variation, product }) {
  let price = null;
  let salePrice = null;
  let totalPrice = null;
  let linePrice = null;
  let originalLinePrice = null;
  let priceType = "regular";

  if (variation) {
    const {
      original_base_gross_price,
      base_gross_price,
      discounted_gross_price,
      total_gross_price,
      company_special_price,
    } = variation;

    totalPrice = total_gross_price;
    price = original_base_gross_price;

    if (company_special_price) {
      priceType = "special";
      salePrice = company_special_price;
      return {
        price,
        salePrice,
        totalPrice,
        priceType,
      };
    }

    // no discount specified
    if (!discounted_gross_price) {
      // means that tier pricing is applied (overrides base gross price)
      if (original_base_gross_price > base_gross_price) {
        salePrice = base_gross_price;
        return {
          price,
          salePrice,
          totalPrice,
          priceType,
        };
      }
    }

    // can be null
    salePrice = discounted_gross_price;
    return {
      price,
      salePrice,
      totalPrice,
      priceType,
    };
  } else if (product) {
    const {
      min_base_gross_price,
      min_discounted_gross_price,
      company_special_price,
      original_total_gross_price,
      discount_sum,
      total_gross_price,
    } = product;

    price = min_base_gross_price;
    linePrice = total_gross_price;
    if (discount_sum) originalLinePrice = original_total_gross_price;
    if (company_special_price) {
      priceType = "special";
      salePrice = company_special_price || discount_sum;
      return {
        price,
        salePrice,
        totalPrice,
        priceType,
        linePrice: total_gross_price,
        originalLinePrice: original_total_gross_price,
      };
    }
    salePrice = min_discounted_gross_price;
  }

  return {
    price,
    salePrice,
    totalPrice,
    priceType,
    linePrice,
    originalLinePrice,
  };
}

export function getOrderPrices(order) {
  const {
    total_net = null,
    total_gross = null,
    //total_gross_discount = null,
    total_promocode_discount = null,
  } = order || {};
  return {
    subtotal: total_gross,
    vat: total_net - total_gross,
    //vat       : 0,
    shipping: 0,
    //promotion : total_gross_discount + total_promocode_discount,
    promotion: total_promocode_discount,
    total: total_gross + (total_net - total_gross) - total_promocode_discount,
  };
}

export function getCartPrices(cart) {
  const { total_gross = null } = cart || {};
  return {
    totalPrice: total_gross,
  };
}

export const capitalizeFirstLetter = (string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
